module.exports = __webpack_public_path__ + "static/media/notetakerimage.9189c89c.jpg";